import type { SVGProps } from 'react';

const SvgMoveBottom = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentcolor"
      d="M15.71 12.692a.996.996 0 1 0-1.41-1.41l-1.29 1.29v-5.59c0-.55-.45-1-1-1s-1 .45-1 1v5.59l-1.29-1.29a.996.996 0 1 0-1.41 1.41l3 3c.2.2.45.29.71.29s.51-.1.71-.29l3-3zM16 15.982H8c-.55 0-1 .45-1 1s.45 1 1 1h8c.55 0 1-.45 1-1s-.45-1-1-1"
    />
  </svg>
);
export default SvgMoveBottom;
